import { render, staticRenderFns } from "./LabelingPoints.vue?vue&type=template&id=562703c8&scoped=true"
import script from "./LabelingPoints.vue?vue&type=script&lang=js"
export * from "./LabelingPoints.vue?vue&type=script&lang=js"
import style0 from "./LabelingPoints.vue?vue&type=style&index=0&id=562703c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562703c8",
  null
  
)

export default component.exports